module.exports = __webpack_public_path__ + "img/fb-icon.e46db96f.svg";